"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavPanelMainRender = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _Main = require("./Main.style");
var _menuItems = require("../../../../../constants/menuItems");
var _Footer = _interopRequireDefault(require("../Footer"));
var _Header = _interopRequireDefault(require("../Header"));
const hasOverflow = customRender => customRender === _menuItems.CUSTOM_DROPDOWN_INTELLIGENCE_PAGES || customRender === _menuItems.CUSTOM_DROPDOWN_COMMODITIES;
class NavPanelMainRender extends _react.default.PureComponent {
  handleClickOutside() {
    const isModalOpen = document.querySelector('[aria-label="sh-analytics--modal"]');
    if (isModalOpen) return;
    this.props.onClose();
  }
  render() {
    const {
      announcementsRead,
      announcements,
      unreadAnnouncementsCount,
      headerTitle,
      hasBack,
      selectedFooterSection,
      servicesNav,
      children,
      onBack,
      onSelectedFooterSectionChange,
      onFooterClose,
      onClose,
      customRender
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Main.Wrapper, {
      "data-test-id": "res-menu-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_Main.BgOverlay, {
      onClick: onClose
    }), hasBack && /*#__PURE__*/_react.default.createElement(_Header.default, {
      title: headerTitle,
      onBack: onBack
    }), /*#__PURE__*/_react.default.createElement(_Main.ItemsPanel, {
      hasOverflow: hasOverflow(customRender),
      "data-test-id": "res-primary-menu-".concat(headerTitle.toLowerCase()),
      hasHeader: hasBack
    }, children), /*#__PURE__*/_react.default.createElement(_Footer.default, {
      announcementsRead: announcementsRead,
      unreadAnnouncementsCount: unreadAnnouncementsCount,
      announcements: announcements,
      selectedFooterSection: selectedFooterSection,
      items: servicesNav,
      onSelectedFooterSectionChange: onSelectedFooterSectionChange,
      onFooterClose: onFooterClose
    }));
  }
}
exports.NavPanelMainRender = NavPanelMainRender;
var _default = exports.default = (0, _reactClickOutside.default)(NavPanelMainRender);